export default "__VITE_ASSET__fac3944b__"